import React from "react";
import ContactUsForm from "../../ContactPage/ContactUsForm";
import Abstraction from "../../../assets/Images/instructor22.png";
const ContactFormSection = () => {
  return (
    <div className="mx-auto md:flex md:gap-16 ">
      <div className="flex items-center justify-center">
        <img src={Abstraction} alt="" className="hidden md:block translate-y-10 -translate-x-10" />
      </div>
      <div>
        <h1 className="text-center text-4xl font-semibold">Get in Touch</h1>
        <p className="text-center text-richblack-300 mt-3">
          We&apos;d love to here for you, Please fill out this form.
        </p>
        <div className="mt-12 mx-auto">
          <ContactUsForm />
        </div>
      </div>
    </div>
  );
};

export default ContactFormSection;
